export const language: any = {
  title: 'Ingredients',
  select_all: 'Select all',
  deselect_all: 'Deselect all',
  add: 'Add ingredients',
  add_title: 'Please select how to add ingredients.',
  add_by_list: 'Add ingredients',
  add_total: 'Add a total of {number} ingredients',
  selecting: 'Total ingredients',
  filter_title: 'Sort selection',
  filter_newest: 'Latest',
  filter_oldest: 'Old shoot',
  filter_alphabet: 'Alphabetical order',
  get_recipe: 'Get AI cooking recommendations',
  search_placeholder: 'Please enter your search term.',
  nodata: 'There is no material.',
  request: 'Add ingredients',
  recipe_title: 'Recommended dishes',
  option: {
    title: 'Select option',
    desc: 'Selecting an option is not required.',
    complete: 'Complete',
    reset: 'Reset',
  },
  msg: {
    msg_7: "Would you like to add selected ingredients?",
    msg_8: `
      <p>Would you like to add selected ingredients?</p>
      <p class="text-[11px] font-normal">(<span class="text-primary">{name}</span> are excluded as they are included in existing food ingredients.)</p>
    `,
    msg_9: "Would you like to add the selected ingredients to your shopping cart?",
    msg_10: `
      <p>Would you like to add the selected ingredients to your shopping cart?<br />
      <p class="text-[11px] font-normal">(<span class="text-primary">{name}</span> are excluded as they are included in existing food ingredients.)</p>
    `,
    confirm: 'Add',
    cancel: 'Cancel',
    not_ingredient: 'It seems that the content you entered is not a cooking ingredient.<br />Please check again.',
    ai_failed: 'An error occurred while entering the ingredient.<br />Please try again later.',
    ingredient_exist_should_exclued: `(<span class="text-primary">{name}</span> are excluded as they are included in existing food ingredients.)`
  },
  history: "Image analysis history",
  myIngredient: "My ingredients",
  history_no_data: "No history available",
  history_take_photo: "Take or choose a photo",
}
